// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__36EsO","itemTitle":"ClientEmergencyInfo_itemTitle__2SmsI","itemText":"ClientEmergencyInfo_itemText__2GAxM"};